import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs/index';
import { CamerallaAuthService } from "../../shared/services/authentication-services/cameralla-auth.service";

@Injectable()
export class AuthCamerallaInterceptor implements HttpInterceptor {
    constructor(private injector: Injector, private authService: CamerallaAuthService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let headers = {
        };
        
        // if there is Anonymous header, don't handle the request, and remove this flag
        if (req.headers.get('Anonymous')) {
            const newHeaders = req.headers.delete('Anonymous')
            const newRequest = req.clone({ headers: newHeaders });
            return next.handle(newRequest);
        } else {
            //Temp hard code for cheating
            headers['Authorization'] = (this.authService && this.authService.getLocalUserInfo() && this.authService.getLocalUserInfo().hasOwnProperty('accessToken') && this.authService.getLocalUserInfo()['accessToken']) ? this.authService.getLocalUserInfo()['accessToken'] : 'undefined';

            headers['UserId'] = (this.authService &&
                this.authService.getLocalUserInfo() && this.authService.getLocalUserInfo().hasOwnProperty('id') && this.authService.getLocalUserInfo()['id']) ? +this.authService.getLocalUserInfo()['id'] : 'undefined';

            req = req.clone({
                setHeaders: headers,
                withCredentials: true
            });

            return next.handle(req);
        }
    }
}
